import React from 'react';
import {useForm} from 'react-hook-form';
import {generateRoute, useRoutes} from '../../routing/RouteProvider';
import {useHistory} from 'react-router';
import {formatISO, startOfToday} from 'date-fns';
import FulltextInput from './fields/FulltextInput';

const NavbarSearchForm = ({className}) => {
    const routes = useRoutes();
    const history = useHistory();
    const filterPath = query => generateRoute(routes, 'events', {filter: query});

    const {register, handleSubmit} = useForm();

    const defaultFilter = {
        'end_date_from': formatISO(startOfToday()),
    };

    const handleUserKeyPress = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(onSubmit)();
        }
    };

    const onSubmit = formData => {
        if (formData.fulltext !== '' && formData.fulltext.length > 2) {
            const query = {...defaultFilter, ...formData};
            const url = filterPath(query);
            history.push(url);
        }
    };

    return (
        <label className={'search-wrapper ' + className} htmlFor="fulltextSearch">
            <div className="nav_right_module search_module">
                <button className="icon-left" id="basic-addon9" onClick={() => handleSubmit(onSubmit)()}>
                    <i className="la la-search" />
                </button>
                <div className="search_area">
                    <form onKeyPress={handleUserKeyPress}>
                        <div className="input-group">

                            <FulltextInput
                                register={register}
                            />

                        </div>
                    </form>

                </div>
            </div>
        </label>
    );

};

export default NavbarSearchForm;
